import { recoverTokenInfo } from "@/utils/recoverTokenInfo";
import { useQuery } from "@tanstack/react-query";
import { useDeviceKey } from "./useDeviceKey";

const fetchAttendancesList = async (deviceKey: string, agendaId: string) => {
  if (!agendaId) {
    return "";
  }

  const url = `${import.meta.env.VITE_SMART_DEBRIEF_API}/v0/agenda/${agendaId}/attendees`;

  const initialToken = recoverTokenInfo();

  const response = await fetch(url, {
    method: "GET",
    headers: {
      accept: "text/plain",
      Authorization: `Bearer ${initialToken}`,
      "X-iBabs-Device-Id": deviceKey,
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};

// Type setted just to avoid error getting the "options.enabled"
type UseAttendancesListOptions = {
  enabled?: boolean;
};

export function useAttendancesList(agendaId: string, options: UseAttendancesListOptions = {}) {
  const deviceKey = useDeviceKey();

  return useQuery({
    queryKey: ["attendancesList", agendaId],
    queryFn: () => fetchAttendancesList(deviceKey, agendaId),
    staleTime: 1000 * 5,
    enabled: !!agendaId && options.enabled !== false,
    ...options,
  });
}
